export const ADMIN_UPLOAD_ARTICLE_IMAGE = `
  mutation AdminUploadArticleImage($input: AdminUploadImageInputDto!) {
    adminUploadArticleImage(input: $input) {
      success
      url
      message
    }
  }
`;
